(function () {
  'use strict';

  angular
      .module('tf.retailer.Charts', []);

  d3.selection.prototype.translate = function (x, y) {
    var fn;
    if (_.isFunction(x)) {
      fn = x;
      return this.attr('transform', function () {
        return translateText(fn.apply(this, arguments));
      });
    } else {
      return this.attr('transform', translateText(x, y));
    }

    function translateText(x, y) {
      if (_.isArray(x)) {
        y = x[1];
        x = x[0];
      }
      return 'translate(' + x + ',' + y + ')';
    }
  };

  function randomInt(min, max) {
    return min + Math.floor(((max - min) + 1) * Math.random());
  }

  window.uuid = function () {
    // Per RFC4122 version 4:
    // "x" gets replaced a random hex value 0-F
    // "y" gets replaced with the bits "10rr" where r is a random bit
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (xy) {
      return (xy === 'x' ? randomInt(0, 15) : (8 | randomInt(0, 3))).toString(16);
    });
  };

})();
